/**
 * Restores document scrolling after dashboard pages or dialogs
 * set inline overflow styles on body/html.
 */
export function resetPageScroll() {
  if (typeof document === "undefined") return;

  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("overflow-x");
  document.body.style.removeProperty("overflow-y");
  document.documentElement.style.removeProperty("overflow");
  document.documentElement.style.removeProperty("overflow-x");
  document.documentElement.style.removeProperty("overflow-y");
}

/**
 * Notify viewport-fit dashboards to recalculate row heights after navigation.
 */
export function notifyViewportLayoutChange() {
  if (typeof window === "undefined") return;

  window.requestAnimationFrame(() => {
    window.dispatchEvent(new Event("resize"));
    window.requestAnimationFrame(() => {
      window.dispatchEvent(new Event("resize"));
    });
  });
}

export function syncPageScrollOnRouteChange() {
  resetPageScroll();
  notifyViewportLayoutChange();
}
